import PropTypes from 'prop-types';

function MMWineInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11313)">
                <path
                    d="M18.0826 3.06412C20.7107 3.51086 22.8941 3.56196 22.9594 3.17826C23.0246 2.79456 20.9469 2.12136 18.3188 1.67462C15.6906 1.22788 13.5072 1.17677 13.442 1.56048C13.3767 1.94418 15.4544 2.61738 18.0826 3.06412Z"
                    fill="#FFF9EA"
                />
                <path
                    d="M13.4413 1.56065C13.4413 1.56065 9.87501 5.76106 10.3874 9.46011C10.8998 13.1592 14.5023 14.0565 14.645 15.1742C14.7877 16.292 15.1382 17.5869 14.5655 20.6752C13.9929 23.7635 13.5296 26.4888 13.2282 26.8656C12.9263 27.2424 11.9201 27.8478 10.4902 27.5926C9.51757 27.4191 9.22461 27.6746 8.91968 28.1614C8.74476 28.4411 10.9298 29.058 13.8272 29.5557C16.7218 30.053 18.8033 30.2352 18.7958 29.999C18.7883 29.7627 18.4949 28.7857 17.2229 28.7236C16.6588 28.6958 15.7833 28.3067 15.3666 27.9899C14.7454 27.5179 14.4687 26.8392 14.6415 25.8228C14.8143 24.8064 15.5789 19.4696 16.1151 17.992C16.6512 16.5145 17.0734 15.7109 18.0055 15.261C18.9375 14.811 21.4099 14.2576 22.4731 12.9371C23.3799 11.8111 23.7584 10.782 23.7135 7.9697C23.6687 5.15744 22.9591 3.17967 22.9591 3.17967"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.353 12.0884C12.6793 11.6012 12.2101 10.961 11.8681 10.203C11.5688 9.5391 11.5697 8.73138 11.6785 8.0636C11.7325 7.73273 11.8114 7.44614 11.886 7.24212C11.9236 7.13942 11.9581 7.06296 11.9852 7.01412C11.9884 7.00829 11.9914 7.00318 11.994 6.99872C12.7466 6.73912 13.3421 6.69637 13.8434 6.77993C14.3574 6.86559 14.7934 7.0874 15.2163 7.38222C15.4998 7.57986 15.764 7.79967 16.0419 8.03097C16.1888 8.15322 16.3396 8.27868 16.4991 8.40577C16.9499 8.76491 17.4477 9.11642 18.0509 9.36131C19.237 9.8428 20.2279 9.87407 21.0018 9.7646C21.387 9.71011 21.7153 9.62121 21.982 9.53906C22.0596 9.51515 22.1292 9.49282 22.1921 9.47239C22.0613 10.0367 21.7741 11.0381 21.2613 11.8056C20.9492 12.2728 20.298 12.6663 19.384 12.9036C18.4779 13.1387 17.3486 13.2105 16.1319 13.0657C14.922 12.9218 14.0273 12.5762 13.353 12.0884ZM12.0102 6.97426C12.0132 6.97058 12.0129 6.97164 12.0093 6.97543C12.0096 6.97496 12.0099 6.97457 12.0102 6.97426Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11313">
                    <rect width="30" height="30" fill="white" transform="translate(0.894531 0.584961)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMWineInactive;

MMWineInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMWineInactive.defaultProps = {
    className: null,
};
